<template>
  <div class="not-found">
    <div class="container">
      <img
        src="/img/logo_wekeep.png"
        :alt="$t('lang.notFound.logoAlt')"
        class="logo"
      >
      <h1>{{ $t('lang.notFound.title') }}</h1>
      <p>{{ $t('lang.notFound.message') }}</p>
      <router-link
        to="/"
        class="btn_1"
      >
        {{ $t('lang.notFound.backToHome') }}
      </router-link>
      <img
        src="@/assets/img/404-illustration.svg"
        :alt="$t('lang.notFound.illustrationAlt')"
        class="illustration"
      >
    </div>
  </div>
</template>

<script>

export default {
  name: 'NotFound',

  metaInfo() {
    return {
      title: '404 - Página no encontrada | WeKeep',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Lo sentimos, la página que buscas no existe o ha sido movida.',
        },
        {
          vmid: 'robots',
          name: 'robots',
          content: 'noindex, follow', // Para que Google no la indexe pero sí siga navegando el sitio
        },
      ],
    };
  },
};
</script>

<style scoped>
.not-found {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f8f9fa;
  padding: 20px;
  text-align: center;
}

.container {
  max-width: 500px;
  margin: 0 auto;
  position: relative;
  padding: 40px 20px;
}

.logo {
  max-width: 180px;
  margin-bottom: 25px;
}

h1 {
  font-size: 2.2rem;
  color: #333;
  margin-bottom: 20px;
  font-weight: 600;
}

p {
  font-size: 1.1rem;
  color: #666;
  margin-bottom: 30px;
  line-height: 1.6;
}

.btn_1 {
  margin: 0 auto;
  text-transform: uppercase;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  padding: 12px 30px !important;
  display: inline-block;
}

.illustration {
  max-width: 80%;
  height: auto;
  margin: 40px auto 0;
  display: block;
  max-height: 250px;
  width: auto;
}

@media (max-width: 768px) {
  .container {
    padding: 20px 15px;
  }

  h1 {
    font-size: 1.8rem;
  }

  p {
    font-size: 1rem;
    margin-bottom: 25px;
  }

  .logo {
    max-width: 140px;
    margin-bottom: 20px;
  }

  .btn_1 {
    padding: 10px 25px !important;
    font-size: 0.85rem;
  }

  .illustration {
    max-width: 90%;
    max-height: 200px;
    margin-top: 30px;
  }
}

@media (max-width: 480px) {
  h1 {
    font-size: 1.6rem;
  }

  p {
    font-size: 0.95rem;
  }

  .illustration {
    max-height: 180px;
  }
}
</style>
